// @flow
import React, { useContext } from 'react';
import { Formik } from 'formik';

import { EstimateContext } from '../../contexts/EstimateContext';
import { NativeInferencePoolContext } from '../../contexts/NativeInferencePoolContext';
import { getFormikFormInputsFromColConfigAndInputSource } from '../../common-utils/utils';
import { NATIVE_INFERENCE_POOL_DETAILS_CONFIG } from '../../configuration/native-inference-pool-details';
import {
  NATIVE_INFERENCE_POOL_CCU_MONTHLY_INPUTS_JSON_CONFIG,
  NATIVE_INFERENCE_POOL_TOKEN_BASED_MODELS_JSON_CONFIG,
} from '../../constants';
import { StyledContainer } from '../../common-utils/styledComponents';
import { Form } from '../../formik-utils/formikSUIWrapper';
import { ValidateFormOnMount } from '../../formik-utils/ValidateFormOnMount';
import FormListener from '../../formik-utils/FormListener';
import { PromptIfFormHasUnSavedChanges } from '../presentational/PromptIfFormHasUnSavedChanges';
import { Spacer } from '../presentational/spacing/Spacer';

import { NativeInferencePoolEnabledContainer } from './native-inference-pool-details-inputs-section/NativeInferencePoolEnabledContainer';
import { NativeInferencePoolAccordionsContainer } from './NativeInferencePoolAccordionsContainer';
import { NativeInferencePoolDeleteContainer } from './NativeInferencePoolDeleteContainer';

export const NativeInferencePoolTopLevelContainerForm = () => {
  const estimate = useContext(EstimateContext);
  const nativeInferencePoolDetails = useContext(NativeInferencePoolContext);
  const nativeInferencePoolInputsSource = {
    ...nativeInferencePoolDetails.inputs,
    id: nativeInferencePoolDetails.id,
    name: nativeInferencePoolDetails.name,
    is_enabled: nativeInferencePoolDetails.is_enabled,
    [NATIVE_INFERENCE_POOL_CCU_MONTHLY_INPUTS_JSON_CONFIG]: nativeInferencePoolDetails.ccu,
    [NATIVE_INFERENCE_POOL_TOKEN_BASED_MODELS_JSON_CONFIG]: nativeInferencePoolDetails.models,
  };

  const { initialValues, initialTouched, validationSchema } =
    getFormikFormInputsFromColConfigAndInputSource(
      NATIVE_INFERENCE_POOL_DETAILS_CONFIG,
      nativeInferencePoolInputsSource,
      {
        estimate,
        nativeInferencePoolDetails,
      }
    );

  return (
    <StyledContainer>
      <Formik
        enableReinitialize={true}
        initialTouched={initialTouched}
        initialValues={initialValues}
        onSubmit={() => {}}
        validateOnBlur={true}
        validateOnChange={false}
        validateOnMount={true}
        validationSchema={validationSchema}
      >
        {(formik) => (
          <Form autoComplete="off">
            <ValidateFormOnMount />
            <FormListener formik={formik} />
            <PromptIfFormHasUnSavedChanges />
            <NativeInferencePoolEnabledContainer />
            <NativeInferencePoolDeleteContainer />
            <Spacer y={10} />
            <NativeInferencePoolAccordionsContainer />
          </Form>
        )}
      </Formik>
    </StyledContainer>
  );
};
